import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
interface NavbarProps {
  onJoinBeta: () => void;
  showBackButton?: boolean;
  onBackClick?: () => void;
}
export const Navbar = ({
  onJoinBeta,
  showBackButton,
  onBackClick
}: NavbarProps) => {
  const navigate = useNavigate();
  return <nav className="fixed top-0 w-full bg-white border-b border-gray-100 z-50" data-id="element-1323">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1324">
        <div className="flex justify-between items-center h-16" data-id="element-1325">
          <div className="flex items-center" data-id="element-1326">
            {showBackButton ? <button onClick={onBackClick} className="flex items-center gap-2 text-gray-600 hover:text-[#6366f1] transition-colors" data-id="element-1327">
                <ArrowLeft size={20} data-id="element-1328" />
                Back to Home
              </button> : <span className="text-xl font-bold text-gray-900" data-id="element-1329">
                usegigi.ai
              </span>}
          </div>
        </div>
      </div>
    </nav>;
};